module.exports = __webpack_public_path__ + "img/exenatide_3.94751974.jpg";